import { DecryptData } from "../actions/common";

export const getUserId = () => {
    const data = localStorage.getItem("_id_a");
    const response = DecryptData(data);
    return response;
}